import { gql, useQuery } from "@apollo/client";

import { addAuthVars } from "@teamrota/authlib";

const CHECK_ACCOUNTS_WITH_BLACKLISTED_MEMBERS = addAuthVars(gql`
  query checkAccountsWithBlacklistedMembers(
    $accountIds: [ID!]
    $memberIds: [ID!]
  ) {
    checkAccountsWithBlacklistedMembers(
      accountIds: $accountIds
      memberIds: $memberIds
    ) {
      accountIds
    }
  }
`);

export const useCheckAccountsWithBlacklistedMembers = ({
  accountIds,
  memberIds
}) => {
  const { loading, data } = useQuery(CHECK_ACCOUNTS_WITH_BLACKLISTED_MEMBERS, {
    variables: {
      accountIds,
      memberIds
    }
  });

  const accountsWithBlacklistedMembers =
    data?.checkAccountsWithBlacklistedMembers?.accountIds || [];

  return { loading, accountsWithBlacklistedMembers };
};
